import React from 'react';
import _get from 'lodash/get';

const processItemList = items => {
  return items.map(item => ({
    ...item,
    disabled: _get(item, 'disabled', false),
    options: item.options
      ? item.options.map(option => ({
          ...option,
          disabled: _get(option, 'disabled', false),
        }))
      : [],
  }));
};

export {processItemList};
